module.exports = __webpack_public_path__ + "img/mask-img1.ff0fa185.png";